module.exports = __webpack_public_path__ + "img/mpos-integrate.ed727db4.svg";